import { render, staticRenderFns } from "./RankList.vue?vue&type=template&id=8d6913fc&scoped=true&"
import script from "./RankList.vue?vue&type=script&lang=js&"
export * from "./RankList.vue?vue&type=script&lang=js&"
import style0 from "./RankList.vue?vue&type=style&index=0&id=8d6913fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6913fc",
  null
  
)

export default component.exports